import PropTypes from "prop-types"
import React from "react"

export const CircledClose = ({ height = 20, width = 20, fill = "#1D72F4", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <circle
      cx="10"
      cy="10"
      r="9"
      stroke={fill}
      strokeWidth="1.5"
      fill="none"
    />
    <path
      d="M6.5 6.5L13.5 13.5M13.5 6.5L6.5 13.5"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

CircledClose.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string
}
